// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"9ce59649","859":"6cf9bcac"}[chunkId] + ".chunk.js";
};